import React, { createContext, useContext } from "react";

export const BuilderCtx = createContext({ editing: false, selectedId: null, onSelect: () => {}, onEditText: () => {} });
export const SectionCtx = createContext(null);

// Inline-editable text. Outside the builder it renders as plain markup.
export const T = ({ f, value, as: Tag = "span", className = "", children, multiline = false }) => {
    const { editing, onEditText } = useContext(BuilderCtx);
    const sid = useContext(SectionCtx);
    if (!editing) return <Tag className={className}>{children ?? value}</Tag>;
    return (
        <Tag
            className={`${className} rhm-editable`}
            data-testid={`inline-${sid}-${f}`}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onEditText({ sectionId: sid, field: f, value, multiline }); }}
        >
            {children ?? value}
        </Tag>
    );
};

export const SectionFrame = ({ section, children }) => {
    const { editing, selectedId, onSelect } = useContext(BuilderCtx);
    if (!editing) return <SectionCtx.Provider value={section.id}>{children}</SectionCtx.Provider>;
    return (
        <SectionCtx.Provider value={section.id}>
            <div
                className={`relative ${selectedId === section.id ? "rhm-frame-selected" : "rhm-frame"}`}
                data-testid={`preview-section-${section.id}`}
                onClick={() => onSelect(section.id)}
            >
                <div className="absolute top-2 left-2 z-30 mono text-[9px] tracking-[0.16em] bg-gold text-black px-2 py-1 pointer-events-none">
                    {section.name || section.type}
                </div>
                {children}
            </div>
        </SectionCtx.Provider>
    );
};
